module.exports = __webpack_public_path__ + "img/Patryk.adf4b39b.jpg";